import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleDprSearch = {
  namespaced: true,

  state: {
    name: 'dpr-search',
    dpr: null,
    dprFiles: null,
    currentDprMainId: null,
  },

  mutations,
  getters,
  actions
}

export default moduleDprSearch;